export const HOME = '/';
export const LOGIN = '/login'
export const REGISTER = '/register'
export const PROFILE = '/profile'
export const CAMPAIGNS = '/campaigns'
export const CAMPAIGN = '/campaigns/:id'
